import '../sass/Download.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import CV from '../assets/CV.pdf'

function Download() {
    return <div className="download" id='download'>
        <h1>TELECHARGER MON CV :</h1>
        <div className="myCV">
            <a href={CV} download="CV Lilian Schott" target='_blank' rel="noopener noreferrer" className='download-btn'>
                <FontAwesomeIcon icon={faDownload} size='xl' />
                TELECHARGER
            </a>
        </div>
    </div>
}
export default Download
